var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-lx",
    _vm._b(
      { on: { saveClick: _vm.saveClick } },
      "dialog-lx",
      _vm.dialogData,
      false,
      true
    ),
    [
      _c("div", { staticClass: "content-main" }, [
        _c("div", { staticClass: "dialog-content" }, [
          _c(
            "div",
            { staticClass: "content-header" },
            [
              _c("el-input", {
                staticStyle: { margin: "0 16px" },
                attrs: {
                  placeholder: _vm.$t("teamDetail.QSRXSXM"),
                  size: "mini",
                },
                nativeOn: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.seachStudentTableData.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.inputVal,
                  callback: function ($$v) {
                    _vm.inputVal = $$v
                  },
                  expression: "inputVal",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.seachStudentTableData },
                },
                [_vm._v(_vm._s(_vm.$t("teamDetail.CX")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-box" },
            [
              _c("c-table", {
                ref: "c-table",
                attrs: {
                  tableData: _vm.studentTableData,
                  ISChangeCheckout: false,
                  tableHeader: _vm.studentListTableHeader,
                  TableHeight: "363px",
                },
                on: { operation: _vm.operation },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }